function addScript(scripts, fn) {
	if (!Array.isArray(scripts)) {
		scripts = [scripts];
	}
	function addScriptImpl() {
		const src = scripts.shift();
		var script = document.createElement("script");
		script.onload = script.onreadystatechange = function () {
			if (!this.readyState || /ded|co/.test(this.readyState)) {
				script.onload = script.onreadystatechange = null;
				if (!scripts.length) {
					fn && fn(script);
					script = null;
				} else {
					script = null;
					addScriptImpl();
				}
			}
		};
		script.async = true;
		script.src = src;
		document.head.appendChild(script);
	}
	addScriptImpl();
}

function mq (mediaQuery) {
	if (window.matchMedia) {
		try {
			var mql = window.matchMedia(mediaQuery);
			return mql.matches;
		}
		catch (e) {
		}
	}
}

export { addScript, mq };